import { render, staticRenderFns } from "./BookInProductForm.vue?vue&type=template&id=1ecafe15&"
import script from "./BookInProductForm.vue?vue&type=script&lang=js&"
export * from "./BookInProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports